import type { Condition } from '../../../hooks/useProductData';
import { getHumanizedMinValue } from '../../humanization';

export const getAccountingConditions = (item): Condition[] => {
  // Обслуживание, Мобильное приложение
  const conditions = [];

  const prices = { from: item.price, to: item.priceTo };
  conditions.push({ value: getHumanizedMinValue(prices, ' ₽/мес'), description: 'Обслуживание', wide: true });

  const mobile = item.dictAdvantages?.includes('mobile');
  mobile && conditions.push({ value: 'Да', description: 'Мобильное приложение' });

  return conditions;
};
